/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  FirmwareControllerDeleteV1PathParameters,
  FirmwareControllerFindOneV1PathParameters,
  FirmwareControllerSendV1PathParameters,
  FirmwareDto,
  FirmwareListDto,
  SendUpdateDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class FirmwareService {
  private readonly http = inject(HttpClient);
  /**
   * Creates a firmware
   */

  create<TData = void>(firmwareDto: FirmwareDto): Observable<TData> {
    const formData = new FormData();
    formData.append(`file`, firmwareDto.file);
    formData.append(`name`, firmwareDto.name);
    formData.append(`model`, firmwareDto.model);
    formData.append(`version`, firmwareDto.version);

    return this.http.post<TData>(`/devices/v1/firmware`, formData);
  }
  /**
   * Deletes a firmware
   */

  delete<TData = void>({ id }: FirmwareControllerDeleteV1PathParameters): Observable<TData> {
    return this.http.delete<TData>(`/devices/v1/firmware/${id}`);
  }
  /**
   * Returns a firmware
   */

  findOne<TData = void>({ id }: FirmwareControllerFindOneV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/firmware/${id}`);
  }
  /**
   * Returns a list of all firmwares
   */

  findAll<TData = void>(firmwareListDto: FirmwareListDto): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/firmware/search`, firmwareListDto);
  }
  /**
   * Sends a firmware update
   */

  send<TData = void>({ id }: FirmwareControllerSendV1PathParameters, sendUpdateDto: SendUpdateDto): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/firmware/${id}/send`, sendUpdateDto);
  }
}
